"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ContractServiceEditor = class ContractServiceEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getConfiguration(...args) {
        switch (this.mode) {
            case 'addService':
                return {
                    isEditable: true,
                    isDeletable: false,
                    isServiceReadonly: false,
                };
            case 'editService':
                return {
                    isEditable: !this.service.locked,
                    isDeletable: !this.service.locked,
                    isServiceReadonly: this.service.locked,
                };
            case 'addServiceFee':
                return {
                    isEditable: true,
                    isDeletable: true,
                    isServiceReadonly: true,
                    isServiceFeeReadonly: false
                };
            case 'editServiceFee':
                return {
                    isEditable: !this.fee.locked,
                    isDeletable: !this.fee.locked,
                    isServiceReadonly: true,
                    isServiceFeeReadonly: this.fee.locked
                };
        }
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    service;
    onService(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("service");
    }
    fee;
    onFee(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("fee");
    }
    mode;
    onMode(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("mode");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    isEditable;
    async $$load_isEditable() {
        return this.getConfiguration().isEditable;
    }
    isDeletable;
    async $$load_isDeletable() {
        return this.getConfiguration().isDeletable;
    }
    isServiceReadonly;
    async $$load_isServiceReadonly() {
        return this.getConfiguration().isServiceReadonly;
    }
    isServiceFeeReadonly;
    async $$load_isServiceFeeReadonly() {
        return this.getConfiguration().isServiceFeeReadonly;
    }
    billingCategories;
    async $$load_billingCategories() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } });
    }
    messages;
    item;
    async $$load_item() {
        return this.service || this.$fn.schemaDefaults('CreateContractService', {
            valid_from: this.contract.lifecycle.valid_from,
            contract_id: this.contract.id
        });
    }
    feeItem;
    async $$load_feeItem() {
        return this.fee ||
            this.$fn.schemaDefaults('CreateContractServiceFee', {
                unit: _.get(this.item, 'service.unit'),
                contract_id: this.contract.id,
                service_id: _.get(this.item, 'id'),
            });
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    services;
    async $$load_services() {
        return this.$fn.fetch('suggest_product', {
            parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
        }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]));
    }
    invoiceGroups;
    async $$load_invoiceGroups() {
        return this.$fn.fetch('list_product_invoice_group');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_7307096920626688_multiple;
    dataMembers = ['formId', 'labelAlign', 'isEditable', 'isDeletable', 'isServiceReadonly', 'isServiceFeeReadonly', 'billingCategories', 'messages', 'item', 'feeItem', 'currencies', 'services', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_7307096920626688_multiple'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                labelAlign: "right",
                isEditable: null,
                isDeletable: null,
                isServiceReadonly: null,
                isServiceFeeReadonly: null,
                billingCategories: null,
                messages: {
                    addService: {
                        title: this.$fn.pgettext("Contract", "Add Service"),
                    },
                    editService: {
                        title: this.$fn.pgettext("Contract", "Edit Service"),
                    },
                    addServiceFee: {
                        title: this.$fn.pgettext("Contract", "Add Service Fee"),
                    },
                    editServiceFee: {
                        title: this.$fn.pgettext("Contract", "Edit Service Fee"),
                    },
                },
                item: null,
                feeItem: null,
                currencies: null,
                services: null,
                invoiceGroups: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "lg",
                },
                b_7307096920626688_multiple: false,
            },
        };
    }
    get currentObjectType() {
        if (this.loaded) {
            return this.mode.indexOf('Fee') > -1 ? 'contract_service_fee' : 'contract_service';
        }
        return null;
    }
    get displayFee() {
        if (this.loaded) {
            return this.mode !== 'editService';
        }
        return null;
    }
    get displayFeeDates() {
        if (this.loaded) {
            return this.displayFee && this.mode !== 'addService';
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.messages[this.mode].title,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8826_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_8832_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_8830_getActionArgs($event) {
        return {
            objectType: this.currentObjectType,
            op: "upsert",
            data: this.mode === 'addService'
                ? _.extend({}, this.item, { fees: [_.extend(this.feeItem, { valid_from: this.item.valid_from, valid_to: this.item.valid_to })] })
                : (this.currentObjectType == 'contract_service' ? this.item : this.feeItem),
            options: {
                parameters: {
                    rev: this.contract.revision_number,
                },
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_3054425420812800_setData_8834_getActionArgs($event) {
        return {
            path: "item.name",
            value: $event.data.option.name,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_3054425420812800_setData_8836_getActionArgs($event) {
        return {
            path: "item.service_id",
            value: $event.data.option.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_3054425420812800_setData_8838_getActionArgs($event) {
        return {
            path: "feeItem.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_3054425420812800_optionSelected(event, scope) {
        return await this.actions.evh_3054425420812800_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_4704362798300200_closeModal_8842_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_4704362798300200_request_8840_getActionArgs($event) {
        return {
            operation: "update_contract_service_fee",
            data: {
                id: this.feeItem.id,
                etag: this.feeItem.etag,
                locked: true
            },
        };
    }
    async evh_4704362798300200_clickPreventStop(event, scope) {
        return await this.actions.evh_4704362798300200_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_8846_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1548630417156826_request_8844_getActionArgs($event) {
        return {
            operation: "update_contract_service",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                locked: true
            },
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_8850_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1419464017721962_request_8848_getActionArgs($event) {
        return {
            operation: "delete_contract_service",
            data: this.item,
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_8854_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_2186679009640457_request_8852_getActionArgs($event) {
        return {
            operation: "delete_contract_service_fee",
            data: this.feeItem,
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1037450307673255_clickPreventStop(event, scope) {
        return await this.actions.evh_1037450307673255_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8826 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8826_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8825 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8826,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8825],
        });
        const act_2248226175642056_closeComponent_8828 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_8827 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_8828,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8827],
        });
        const act_1040167445267876_closeModal_8832 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_8832_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_8831 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_8832,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_8830 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_8830_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_8831],
        });
        const evh_1040167445267876_submit_8829 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_8830,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8829],
        });
        const act_3054425420812800_setData_8834 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3054425420812800_setData_8834_getActionArgs,
            events: [],
        });
        const evh_3054425420812800_optionSelected_8833 = new core_1.actions.EventHandlerImpl({
            action: act_3054425420812800_setData_8834,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_3054425420812800_setData_8836 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3054425420812800_setData_8836_getActionArgs,
            events: [],
        });
        const evh_3054425420812800_optionSelected_8835 = new core_1.actions.EventHandlerImpl({
            action: act_3054425420812800_setData_8836,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_3054425420812800_setData_8838 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3054425420812800_setData_8838_getActionArgs,
            events: [],
        });
        const evh_3054425420812800_optionSelected_8837 = new core_1.actions.EventHandlerImpl({
            action: act_3054425420812800_setData_8838,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_3054425420812800_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3054425420812800_optionSelected_8833, evh_3054425420812800_optionSelected_8835, evh_3054425420812800_optionSelected_8837],
        });
        const act_4704362798300200_closeModal_8842 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_4704362798300200_closeModal_8842_getActionArgs,
            events: [],
        });
        const evh_4704362798300200_success_8841 = new core_1.actions.EventHandlerImpl({
            action: act_4704362798300200_closeModal_8842,
            event: "success",
            displayName: "closeModal",
        });
        const act_4704362798300200_request_8840 = new core_1.actions.RequestAction({
            actionArgs: this.act_4704362798300200_request_8840_getActionArgs,
            displayName: "lockServiceFee",
            events: [evh_4704362798300200_success_8841],
        });
        const evh_4704362798300200_clickPreventStop_8839 = new core_1.actions.EventHandlerImpl({
            action: act_4704362798300200_request_8840,
            event: "click.prevent.stop",
            displayName: "lockServiceFee",
        });
        const evh_4704362798300200_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4704362798300200_clickPreventStop_8839],
        });
        const act_1548630417156826_closeModal_8846 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_8846_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_8845 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_8846,
            event: "success",
            displayName: "closeModal",
        });
        const act_1548630417156826_request_8844 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_8844_getActionArgs,
            displayName: "lockService",
            events: [evh_1548630417156826_success_8845],
        });
        const evh_1548630417156826_clickPreventStop_8843 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_8844,
            event: "click.prevent.stop",
            displayName: "lockService",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_8843],
        });
        const act_1419464017721962_closeModal_8850 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_8850_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_success_8849 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_8850,
            event: "success",
            displayName: "closeModal",
        });
        const act_1419464017721962_request_8848 = new core_1.actions.RequestAction({
            actionArgs: this.act_1419464017721962_request_8848_getActionArgs,
            displayName: "deleteService",
            events: [evh_1419464017721962_success_8849],
        });
        const evh_1419464017721962_clickPreventStop_8847 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_request_8848,
            event: "click.prevent.stop",
            displayName: "deleteService",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_8847],
        });
        const act_2186679009640457_closeModal_8854 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_8854_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_success_8853 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_8854,
            event: "success",
            displayName: "closeModal",
        });
        const act_2186679009640457_request_8852 = new core_1.actions.RequestAction({
            actionArgs: this.act_2186679009640457_request_8852_getActionArgs,
            displayName: "deleteServiceFee",
            events: [evh_2186679009640457_success_8853],
        });
        const evh_2186679009640457_clickPreventStop_8851 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_request_8852,
            event: "click.prevent.stop",
            displayName: "deleteServiceFee",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_8851],
        });
        const act_1037450307673255_closeComponent_8856 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1037450307673255_clickPreventStop_8855 = new core_1.actions.EventHandlerImpl({
            action: act_1037450307673255_closeComponent_8856,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1037450307673255_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1037450307673255_clickPreventStop_8855],
        });
        return {
            act_7315092382398562_closeModal_8826,
            evh_7315092382398562_close_8825,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_8828,
            evh_2248226175642056_close_8827,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_8832,
            evh_1040167445267876_success_8831,
            act_1040167445267876_crud_8830,
            evh_1040167445267876_submit_8829,
            evh_1040167445267876_submit,
            act_3054425420812800_setData_8834,
            evh_3054425420812800_optionSelected_8833,
            act_3054425420812800_setData_8836,
            evh_3054425420812800_optionSelected_8835,
            act_3054425420812800_setData_8838,
            evh_3054425420812800_optionSelected_8837,
            evh_3054425420812800_optionSelected,
            act_4704362798300200_closeModal_8842,
            evh_4704362798300200_success_8841,
            act_4704362798300200_request_8840,
            evh_4704362798300200_clickPreventStop_8839,
            evh_4704362798300200_clickPreventStop,
            act_1548630417156826_closeModal_8846,
            evh_1548630417156826_success_8845,
            act_1548630417156826_request_8844,
            evh_1548630417156826_clickPreventStop_8843,
            evh_1548630417156826_clickPreventStop,
            act_1419464017721962_closeModal_8850,
            evh_1419464017721962_success_8849,
            act_1419464017721962_request_8848,
            evh_1419464017721962_clickPreventStop_8847,
            evh_1419464017721962_clickPreventStop,
            act_2186679009640457_closeModal_8854,
            evh_2186679009640457_success_8853,
            act_2186679009640457_request_8852,
            evh_2186679009640457_clickPreventStop_8851,
            evh_2186679009640457_clickPreventStop,
            act_1037450307673255_closeComponent_8856,
            evh_1037450307673255_clickPreventStop_8855,
            evh_1037450307673255_clickPreventStop,
            save: act_1040167445267876_crud_8830,
            lockServiceFee: act_4704362798300200_request_8840,
            lockService: act_1548630417156826_request_8844,
            deleteService: act_1419464017721962_request_8848,
            deleteServiceFee: act_2186679009640457_request_8852,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractServiceEditor.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceEditor.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractServiceEditor.prototype, "service", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('service'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceEditor.prototype, "onService", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractServiceEditor.prototype, "fee", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fee'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceEditor.prototype, "onFee", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], ContractServiceEditor.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('mode'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceEditor.prototype, "onMode", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], ContractServiceEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceEditor.prototype, "onSize", null);
ContractServiceEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractServiceEditor);
exports.default = ContractServiceEditor;
vue_property_decorator_1.Vue.component("ContractServiceEditor", ContractServiceEditor);
